import React, { useState, useEffect } from "react";
import { Grid, LinearProgress, Typography } from "@mui/material";
import ListResponsive from "../other/ListResponsive";
import PostCard from "../layout/PostCard";
import { handlePaging } from "../api/APIUtilities";
import PageCard from "../layout/PageCard";
import { getEnvironmentVariable } from "../../global/environmentVariables";

export default function PostGallery(props) {
  const {
    tag,
    tagList,
    searchLimit,
    startDate,
    endDate,
    status,
    authorId,
    editMode,
    pageType,

    doSearch,
    actionButton,
    loadMoreHref,
    searchLabel,
    sortAscending,
  } = props;
  const [loading, setLoading] = useState(true);

  const [posts, setPosts] = useState(null);
  const [nextKey, setNextKey] = useState(null);
  const [hasMore, setHasMore] = useState(true);
  const [isSearching, setIsSearching] = useState(null);

  const searchValues = {
    env: getEnvironmentVariable("COMPANY_FLAG"),
    limit: searchLimit || 24,
    startDate: startDate || null,
    endDate: endDate || null,
    pageType: pageType || "post",
    "tags[]": tagList || null,
    tag: tag || null,
    "expand[]": ["featuredImage"],
    sortAscending: sortAscending || false,
  };

  if (!status) {
    searchValues["status"] = "published";
  }
  if (authorId) {
    searchValues["authorId"] = authorId;
  }

  const search = async () => {
    if (!searchValues.startDate) {
      delete searchValues.startDate;
    }
    if (!searchValues.endDate) {
      delete searchValues.endDate;
    }
    if (!searchValues.tag) {
      delete searchValues.tag;
    }
    if (!searchValues["tags[]"]) {
      delete searchValues["tags[]"];
    }

    var getApiData = await handlePaging(
      "/pages",
      searchValues,
      nextKey,
      setNextKey
    );

    if (getApiData.length !== searchValues.limit) {
      setHasMore(false);
    }

    setPosts(posts?.length ? [...posts, ...getApiData] : getApiData);
    setIsSearching(false);
  };

  useEffect(() => {
    const check = async () => {
      try {
        if (!posts) await search(true);
      } catch (err) {
        setPosts(null);
      } finally {
        setLoading(false);
      }
    };
    check();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      {!posts ? (
        <LinearProgress />
      ) : posts?.length > 0 ? (
        <>
          <ListResponsive
            originalList={loading ? null : posts}
            doSearch={doSearch}
            actionButton={actionButton}
            searchProps={{
              label: searchLabel ? searchLabel : "Search Posts",
              performSearch: (originalList, searchText) => {
                if (!searchText || searchText === "") {
                  return originalList;
                } else {
                  var filteredList = originalList.filter(function (el) {
                    for (let i = 0; i < el?.tags?.length; i++) {
                      if (el?.tags[i]?.toLowerCase().includes(searchText))
                        return true;
                    }
                    if (el?.title?.toLowerCase().includes(searchText))
                      return true;
                    if (el?.subTitle?.toLowerCase().includes(searchText))
                      return true;
                    if (el?.permalink?.toLowerCase().includes(searchText))
                      return true;
                    if (el?.body?.toLowerCase().includes(searchText))
                      return true;

                    return false;
                  });
                  return filteredList;
                }
              },
            }}
            loadMore={search}
            loadMoreHref={loadMoreHref}
            hasMore={hasMore}
            scrollToTop
            rowProps={{
              mapFunction: (post, index) => (
                <>
                  {pageType === "page" ? (
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      sx={{ p: 0.5 }}
                      key={post?.id || index}
                    >
                      <PageCard
                        post={post}
                        editMode={editMode}
                        key={post?.id || index}
                      />
                    </Grid>
                  ) : (
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      md={4}
                      sx={{ p: 0.5 }}
                      key={post?.id || index}
                    >
                      <PostCard
                        post={post}
                        editMode={editMode}
                        key={post?.id || index}
                      />
                    </Grid>
                  )}
                </>
              ),
            }}
          />
          {isSearching && <LinearProgress />}
        </>
      ) : (
        <Typography>{`No ${
          pageType === "page" ? "pages" : "posts"
        } found`}</Typography>
      )}
    </>
  );
}
